import http from "../http/http-config";
import { WorkOccasionQuotationResponse } from "../models/WorkOccasionQuotationResponse";

export default new class getNewOcassionOfWorkQuotation {
    createNewOcassionOfWorkQuotation(model: Record<string, unknown>): Promise<WorkOccasionQuotationResponse> {
        return http.post<WorkOccasionQuotationResponse>(
            "NewOcassionOfWorkQuotation/GetOcassionOfWorkQuotation",
            model,
            { headers: { "Content-Type": "application/json" } }
        ).then(response => response.data);
    }
}
